import React from "react";
import { Link } from "react-router-dom";
import icon from '../assets/icons/infografia.webp';

const Contacto = () => {
  return (
    <div className="container d-flex flex-column align-items-center justify-content-center min-vh-100">
      {/* Título */}
      <div className="w-75 bg-dark text-white py-4 text-center shadow-lg rounded">
        <h1 className="display-5 fw-bold">Descubrenos</h1>
      </div>

            {/* Imagen Representativa */}
      <img src={icon} alt="App Icon" className="mt-4 shadow-lg" 
        style={{ width: "600px", height: "auto", borderRadius: "15px" }} />

      {/* Botón de regreso */}
      <Link to="/preview" className="mt-5">
        <button className="btn btn-outline-primary btn-lg shadow-lg px-5 py-3 rounded-pill">
          Volver a Inicio
        </button>
      </Link>
    </div>
  );
};

export default Contacto;
